import React from 'react';
import { Form, Select } from 'components/ds';
import { CustomSelect } from '../DynamicForm/DynamicForm.styles';
import { FormItemProps } from '../../_types/dynamicFormInterfaces.types';

const {Option} = Select;

interface SelectItemProps {
  item: FormItemProps;
  isDisabled: boolean;
  loading?: boolean;
  onChange?: (value: string, item: FormItemProps) => void;
}

export const SelectItem: React.FC<SelectItemProps> = ({
                                                        item,
                                                        isDisabled,
                                                        loading,
                                                        onChange
                                                      }) => {
  const handleChange = (value: string) => {
    if (onChange) {
      onChange(value, item);
    }
  };
  
  return (
    <Form.Item
      key={item.name}
      name={item.name}
      rules={item.rules}
      initialValue={item.initialValue}
    >
      <CustomSelect
        placeholder={item.label || item.placeholder}
        size="large"
        disabled={isDisabled}
        loading={loading}
        onChange={handleChange}
      >
        {item.options?.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </CustomSelect>
    </Form.Item>
  );
};

export const renderSelectItem = (
  item: FormItemProps,
  isDisabled: boolean,
  loading?: boolean,
  onChange?: (value: string, item: FormItemProps) => void
) => (
  <SelectItem
    item={item}
    isDisabled={isDisabled}
    loading={loading}
    onChange={onChange}
  />
);
